<template>
  <div class="vision">
    <div
      class="mobile-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>
    <div class="container mobile-hide">
      <agile
        ref="imagecarousel"
        :autoplay="false"
        :speed="2000"
        :fade="true"
        :dots="false"
        :nav-buttons="false"
        style="height:400px;overflow:hidden;"
      >
        <div
          class="slide"
          style="background: url('./img/about_slide01.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide02.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide03.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide04.jpg') center center / cover;"
        ></div>
      </agile>
      <div class="slidetextbg"></div>
      <div class="slidetext tablet-offset">{{$t('body.about_slide')}}</div>
      <div
        style="
      width: 100%;
      height: 133px;
      position: absolute;
      top: 370px;
      background: url(./img/about_overlay.png) center center / cover;
      mix-blend-mode:multiply;
      "
      ></div>
      <div class="container" style="position:absolute;top:0;right:0;">
        <agile
          :autoplay="true"
          :speed="2000"
          :autoplay-speed="5000"
          :fade="true"
          :dots="true"
          :nav-buttons="false"
          style="height:500px;overflow:hidden;"
          @beforeChange="syncslide"
        >
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_vision.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_trust.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_persist.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_determin.png" alt width="48" />
            </div>
          </div>
        </agile>
      </div>
    </div>

    <div class="mobile-padding mobile-unpad mobile-bg-blue" style="padding-top:40px;">
      <div class="container" style="text-align:left;margin-bottom:16px;">
        <span class="title-size">{{$t('body.aboutus_vision_title')}}</span>
      </div>
      <div class="container" style="text-align:left;margin-top:16px;margin-bottom:16px;">
        <div class="columns bodygrey" style="padding-bottom:30px;">
          <div
            class="column mobile-column-padding-right"
            @mouseenter="hilight"
            @mouseleave="hilight"
          >
            <div
              class="container middle-separator-left line-bottom-left"
            >{{$t('body.aboutus_vision_title1')}}</div>
            <div class="vision" style="font-size:20px;">{{$t('body.aboutus_vision_p1')}}</div>
          </div>
          <div class="column" @mouseenter="hilight" @mouseleave="hilight">
            <div
              class="container middle-separator-left line-bottom-left"
            >{{$t('body.aboutus_mission_title')}}</div>
            <div class="vision" id="mission"  style="font-size:20px;">{{$t('body.aboutus_mission_p1')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-hide" style="margin-bottom:60px;"></div>
    <div style="position:relative;top:150px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventbus";
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
export default {
  name: "vision",
  mounted() {
    let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
    if  ( this.$i18n.locale == "cn" ){
      self.changeToCN();
    } else {
      self.changeToEN();
    }
        EventBus.$on("changeEN", function() {
      self.changeToEN();
    });
    EventBus.$on("changeCN", function() {
      self.changeToCN();
    });

  },
  methods: {
    hilight(e) {
      console.log(e.target.children[0]);
      let el = e.target;
      let el1 = e.target.children[0];
      el.classList.toggle("blue");
      el1.classList.toggle("blue");
    },
    syncslide() {
      let self = this;
      console.log("syncslide");
      self.$refs.imagecarousel.goToNext();
    },
    changeToEN(){
      $("#mission").css("width", "100%");

    },
    changeToCN(){

      $("#mission").css("width", "103%");
   }
  }
};
</script>


<style scoped lang="scss">
.slide {
  width: 100%;
  height: 400px;
  // background: url("../assets/logo.png");
}

// .column {
//   padding: 0;
// }

.slidetextbg {
  width: 500px;
  height: 400px;
  background: linear-gradient(to right, #013d57dd 70%, #013d5700);
  mix-blend-mode: multiply;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: justify;
  padding: 24px 200px 0 24px;
  font-size: 20px;
}

.slidetext {
  width: 550px;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: left;
  line-height: 29px;
  padding: 24px 200px 0 24px;
  font-size: 25px;
}
.slide-overlay {
  width: calc(1000px - 126px);
  height: inherit;
  font-size: 40px;
  line-height: 1;
  text-align: right;
  color: white;
  border-right: white solid 1px;
  position: relative;
  padding: 0 8px;
  top: 24px;
  // right: -500px;
}

.slide-overlay::after {
  content: "";
  display: block;
  width: 4px;
  height: 100px;
  background: white;
  position: absolute;
  padding-right: 4px;
  top: 0;
  right: 0;
}

.column.blue {
  color: #6d6e70;
}

.vision {
  width: 100%;
  font-weight: 300;
  line-height: 1.1;
  text-align: left;
}

.middle-separator-left {
  color: #aaa;
  font-size: 20px;
  padding-bottom: 3px;
  text-align: left;
  line-height: 1.7;
  margin-top: 16px;
  margin-bottom: 16px;
  transition: all 300ms ease-in-out;
}
.line-bottom-left {
  border-bottom: 1px solid #aaa;
  position: relative;
  transition: all 300ms ease-in-out;
}
.line-bottom-left:before {
  content: "";
  display: block;
  width: 68px;
  height: 8px;
  background: #aaa;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 300ms ease-in-out;
}

.middle-separator-left.blue {
  color: #aaa;
  transition: all 300ms ease-in-out;
}
.line-bottom-left.blue {
  border-bottom: 1px solid #aaa;
  position: relative;
  transition: all 300ms ease-in-out;
}
.line-bottom-left.blue:before {
  content: "";
  display: block;
  width: 68px;
  height: 8px;
  background: #aaa;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 300ms ease-in-out;
}
@media screen and (min-width: 768px) {
  .column.blue {
    color: #013d57;
  }
  .middle-separator-left.blue {
    color: #013d57;
    transition: all 300ms ease-in-out;
  }
  .line-bottom-left.blue {
    border-bottom: 1px solid #013d57;
    position: relative;
    transition: all 300ms ease-in-out;
  }
  .line-bottom-left.blue:before {
    content: "";
    display: block;
    width: 68px;
    height: 8px;
    background: #013d57;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: all 300ms ease-in-out;
  }
.tablet-offset{
    top:30px;
  }
}
@media screen and (min-width: 992px) {
  .tablet-offset{
    top:0px;
  }
}
</style>
